<template>
  <div class="enable-question-effect">
    <el-tooltip
      :disabled="!selectedContent"
      :visible-arrow="false"
      :content="selectedContent"
      placement="top"
    >
      <el-select
        id="question-select"
        v-close-on-zoom
        :value="state.effect.id"
        :placeholder="placeholder"
        :filterable="true"
        :default-first-option="true"
        class="question-select"
        :disabled="readonly"
        :no-data-text="noDataText"
        @input="questionId => selectQuestion(questionId)"
      >
        <el-option
          v-for="question in applicableQuestions"
          :key="question.id"
          :label="question.content.en"
          :value="question.id"
        />
      </el-select>
      <help-tooltip v-if="errors.length" type="error">
        <span v-for="error in errors" :key="error.message">{{ error.message }}</span>
      </help-tooltip>
    </el-tooltip>
  </div>
</template>

<script>
import { get, sortBy, uniqBy } from 'lodash';
import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'toggle-dialogue-effect',
  components: {
    HelpTooltip,
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'type',
    'effectType',
    'placeholder',
    'getDialogueItems'
  ],
  data() {
    return {
      state: {
        effect: {},
      },
    };
  },
  computed: {
    questions() {
      return sortBy(this.getDialogueItems(this.emitter.caseConf) || [], 'options.position');
    },
    applicableQuestions() {
      return this.questions;
    },
    selectedContent() {
      const item = this.questions.find(q => q.id === this.state.effect.id);
      return get(item, 'content.en');
    },
    noDataText() {
      return 'You have no questions to enable/disable';
    },
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(error => error.metadata && error.metadata.scope === 'control');

      return uniqBy(errors, 'message');
    },
  },
  mounted() {
    this.syncState();
    this.emitter.on('process', (nodeOrControl) => {
      // Update internal state when the node data changes
      // outside (e.g. from a CallAction)
      if (nodeOrControl === this.control) {
        this.syncState();
      }
    });
    this.update();
  },
  methods: {
    syncState() {
      this.state.effect = this.getData(this.ikey) || {};
    },
    selectQuestion(questionId) {
      this.state.effect.id = questionId;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: this.effectType,
        ...this.state.effect,
        value: this.type === 'ENABLE',
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
</style>
